<template>
  <el-container>
    <el-header class="nav-container">
      <navbar
        :nav-index="2"
        @nav-items-click="navClick"/>
    </el-header>
    <el-container>
      <el-aside
        width="auto"
        class="aside-container">
        <sidebar
          :items="sidebarItems"
          :create-button-title="permissonWork ? '建立專案' : ''"
          create-button-icon="el-icon-plus"
          main-router="project"
          @quicklyCreate="quicklyCreate"/>
      </el-aside>
      <el-main id="project-main-container">
        <app-main/>
      </el-main>
    </el-container>
    <add-project
      v-if="isCreate"
      @close="isCreate = false"/>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { childrenMenu } from '@/router/modules/project/project'
import { Navbar, Sidebar, AppMain } from './components'
import { workIndexWorkListAPI } from '@/api/projectManagement/task'
import { workTasklableIndexAPI } from '@/api/projectManagement/tag'
import AddProject from '@/views/projectManagement/components/addProject'

export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    AddProject
  },

  data() {
    return {
      isCreate: false,
      sidebarItems: []
    }
  },
  computed: {
    ...mapGetters(['work']),
    permissonWork() {
      return this.work && this.work.work && this.work.work.save
    }
  },
  created() {
    this.sidebarItems = childrenMenu
    this.getProjectMenu()
    this.getTagMenu()
    this.addNotification()
  },

  beforeDestroy() {
    this.$bus.$off('project-setting')
    this.$bus.$off('add-project')
    this.$bus.$off('delete-project')
    this.$bus.$off('recover-project')
  },
  methods: {
    navClick(index) {},

    quicklyCreate() {
      this.isCreate = true
    },

    /**
     * 獲取專案菜單
     */
    getProjectMenu() {
      // 獲取專案列表
      let projectMenu = null
      for (const item of this.sidebarItems) {
        if (item.meta && item.meta.title == '專案') {
          projectMenu = item
          break
        }
      }

      if (projectMenu) {
        workIndexWorkListAPI()
          .then(res => {
            projectMenu.children = []
            for (const item of res.data) {
              projectMenu.children.push({
                path: 'list/' + item.work_id,
                meta: {
                  title: item.name,
                  id: item.work_id
                }
              })
            }
          })
          .catch(() => {})
      }
    },

    /**
     * 獲取標籤菜單
     */
    getTagMenu() {
      let tagMenu = null
      for (const item of this.sidebarItems) {
        if (item.meta && item.meta.title == '標籤') {
          tagMenu = item
          break
        }
      }

      if (tagMenu) {
        workTasklableIndexAPI()
          .then(res => {
            tagMenu.children = []
            for (const item of res.data.list) {
              tagMenu.children.push({
                path: 'tag/' + item.lable_id,
                meta: {
                  title: item.name,
                  params: item
                }
              })
            }
          })
          .catch(() => {})
      }
    },

    /**
     * 通知更新
     */
    addNotification() {
      // 專案設定
      this.$bus.$on('project-setting', (name, id) => {
        for (const item of this.sidebarItems) {
          if (item.meta && item.meta.title == '專案') {
            for (const i in item.children) {
              if (item.children[i].meta.id == id) {
                item.children[i].meta.title = name
                break
              }
            }
          }
        }
      })

      // 專案新增
      this.$bus.$on('add-project', (name, id) => {
        for (const item of this.sidebarItems) {
          if (item.meta && item.meta.title == '專案') {
            item.children.push({
              path: 'list/' + id,
              meta: {
                title: name,
                id: id
              }
            })
            this.$nextTick(() => {
              this.$router.replace({
                name: 'project-list',
                params: {
                  id: id
                }
              })
            })
            break
          }
        }
      })

      // 恢復專案
      this.$bus.$on('recover-project', (name, id) => {
        for (const item of this.sidebarItems) {
          if (item.meta && item.meta.title == '專案') {
            item.children.push({
              path: 'list/' + id,
              meta: {
                title: name,
                id: id
              }
            })
          }
        }
      })

      // 專案刪除
      this.$bus.$on('delete-project', id => {
        for (const item of this.sidebarItems) {
          if (item.meta && item.meta.title == '專案') {
            for (const i in item.children) {
              if (item.children[i].meta.id == id) {
                item.children.splice(i, 1)
                this.$router.replace({
                  name: 'my-task'
                })
                break
              }
            }
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.aside-container {
  position: relative;
  background-color: #2d3037;
  box-sizing: border-box;
  border-right: solid 1px #e6e6e6;
}

.nav-container {
  padding: 0;
  box-shadow: 0px 1px 2px #dbdbdb;
  z-index: 100;
  min-width: 1200px;
}

#project-main-container {
  max-height: 100%;
}

.el-container {
  overflow: hidden;
}
</style>
